import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Bubble, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', (
            _$cc(Button, {
                'ev-click': this.toggleLoading,
                'children': (
                    (this.get('loading')) ?
                        _$ce(2, 'span', '停止 loading', 16) :
                        _$ce(2, 'span', '启动 loading', 16)
                )
            })
        ), 2, 'bubble-demo-actions'),
        _$ce(2, 'div', [
            _$cc(Bubble, {
                'avatar': true,
                'roleName': 'AI 助手',
                'loading': this.get('loading'),
                'content': this.get('content'),
                'variant': 'plain',
                '$blocks': function($blocks) {
                    var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                    return (
                        (
                            (_$blocks['extra'] = function($super) {
                                return '默认 loading';
                            }),
                            (__$blocks['extra'] = function($super, data) {
                                var block = $blocks['extra'];
                                var callBlock = function() {
                                    return _$blocks['extra'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            })
                        ),
                        __$blocks
                    );
                }.call($this, _$em)
            }),
            _$cc(Bubble, {
                'avatar': true,
                'roleName': '工作流引擎',
                'loading': this.get('loading'),
                'content': this.get('content'),
                'variant': 'plain',
                '$blocks': function($blocks) {
                    var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                    return (
                        (
                            (_$blocks['loading'] = function($super) {
                                return (
                                    _$ce(2, 'div', [
                                        _$ce(2, 'span', null, 1, 'bubble-demo-custom-loading-ring'),
                                        _$ce(2, 'span', '正在调度 3 个子任务...', 16)
                                    ], 4, 'bubble-demo-custom-loading')
                                );
                            }),
                            (__$blocks['loading'] = function($super, data) {
                                var block = $blocks['loading'];
                                var callBlock = function() {
                                    return _$blocks['loading'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            })
                        ),
                        (
                            (_$blocks['extra'] = function($super) {
                                return '通过 `loading` 插槽自定义加载区';
                            }),
                            (__$blocks['extra'] = function($super, data) {
                                var block = $blocks['extra'];
                                var callBlock = function() {
                                    return _$blocks['extra'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            })
                        ),
                        __$blocks
                    );
                }.call($this, _$em)
            })
        ], 4, 'bubble-demo-loading-list')
    ], 4, 'bubble-demo-loading');
};